module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "mp",
    class: [("mp-" + _vm.kind), {
      'mp-compact': _vm.compact
    }]
  }, [(!_vm.mediaId) ? _c('div', {
    staticClass: "mp-missing"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n    " + _vm._s(_vm.label) + _vm._s(_vm.missingText) + "\n  ")]) : (_vm.state === 'loading') ? _c('div', {
    staticClass: "mp-placeholder"
  }, [_c('i', {
    staticClass: "fa fa-spinner fa-spin"
  }), (!_vm.compact) ? _c('span', [_vm._v(" Loading " + _vm._s(_vm.label.toLowerCase()) + "…")]) : _vm._e()]) : (_vm.state === 'error') ? _c('div', {
    staticClass: "mp-missing"
  }, [_c('i', {
    staticClass: "fa fa-exclamation-triangle"
  }), _vm._v("\n    " + _vm._s(_vm.error) + "\n  ")]) : [(_vm.kind === 'image') ? _c('img', {
    staticClass: "mp-img",
    attrs: {
      "src": _vm.url,
      "alt": _vm.mediaName || 'Image'
    }
  }) : (_vm.kind === 'video') ? _c('video', {
    staticClass: "mp-video",
    attrs: {
      "src": _vm.url,
      "controls": "",
      "preload": "metadata"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }) : (_vm.kind === 'audio') ? _c('audio', {
    staticClass: "mp-audio",
    attrs: {
      "src": _vm.url,
      "controls": "",
      "preload": "metadata"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
      }
    }
  }) : _c('div', {
    staticClass: "mp-doc"
  }, [_c('i', {
    staticClass: "fa fa-file-pdf-o"
  }), _vm._v(" "), _c('span', {
    staticClass: "mp-doc-name"
  }, [_vm._v(_vm._s(_vm.fileName || _vm.mediaName || 'Document'))])])], _vm._v(" "), (_vm.mediaId && _vm.state !== 'error' && (_vm.showCaption || _vm.canOpen)) ? _c('div', {
    staticClass: "mp-caption"
  }, [(_vm.showCaption && _vm.mediaName) ? _c('span', {
    staticClass: "mp-caption-name"
  }, [_vm._v(_vm._s(_vm.label) + " · " + _vm._s(_vm.mediaName))]) : _vm._e(), _vm._v(" "), (_vm.canOpen) ? _c('a', {
    staticClass: "mp-open",
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        $event.stopPropagation();
        return _vm.open.apply(null, arguments)
      }
    }
  }, [_c('i', {
    staticClass: "fa",
    class: _vm.opening ? 'fa-spinner fa-spin' : 'fa-external-link'
  }), _vm._v(" Open file\n    ")]) : _vm._e()]) : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?{"id":"data-v-f454eb80","transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/MediaPreview.vue
// module id = xcbM
// module chunks = 1